<template>
    <a :data-original-title="__(status)"
       data-placement="top"
       data-toggle="tooltip"
       @click="clickIcon"
    >
        <span :class="label" class="label">{{ acronym }}</span>
    </a>
</template>

<script>
import Events from "../services/Events";

export default {
    name: "DocumentStatusLabel",
    props: {
        status: {
            type: String,
            required: true,
        },
        document: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            label: '',
            acronym: '',
        };
    },
    methods: {
        setStatusData(label, acronym) {
            this.label = label;
            this.acronym = this.__(acronym);
        },
        handleStatusData() {
            switch (this.status) {
                case 'not_confirmed':
                    return this.setStatusData('label-danger', 'not_confirmed_acronym');
                case 'rejected':
                    return this.setStatusData('label-black', 'rejected_acronym');
                case 'cancelled':
                    return this.setStatusData('label-black', 'cancelled_acronym');
                case 'confirmed':
                    return this.setStatusData('label-plain', 'confirmed_acronym');
                default:
                    break;
            }
        },
        clickIcon() {
            if (this.status === 'not_confirmed') {
                Events.$emit('showIncompleteModal', this.document.document_number, this.document.text, this.document.substatus, this.document.pl_ksef_information, this.document.pl_ksef_information_style, this.document.pl_ksef_information_title);
            }
        },
    },
    mounted() {
        this.handleStatusData();
    },
};
</script>
